/** MerchantPro themes use q and create their native search drawer dynamically. */
export function storefrontProfile(input: Record<string, string | undefined>, merchantProDetected: boolean, selectorMatches = false): Record<string, string | undefined> {
  if (input.platform !== 'merchantpro' && !merchantProDetected) return input;
  return {
    ...input,
    platform: 'merchantpro',
    hijackSelector: selectorMatches ? input.hijackSelector : 'input.search__input[name="q"]',
    openSelector: input.openSelector || '[data-toggle-search]',
    desktopFullscreen: input.desktopFullscreen ?? 'true',
    cartUrl: input.cartUrl || '/cart',
  };
}
